import { SectionBaseModel } from '@/components/layout/section/SectionBaseModel';
import { SectionType } from '@/typings/enums/enums';
import { FlowPageSettingsModel } from '@/components/layout/FlowPageSettingsModel';
import { SettingsModel } from '@/components/layout/SettingsModel';
import { SettingsData } from '@/typings/interfaces/data/settings/settings';
import { CampaignModel } from '@/models/CampaignModel';
import { SectionData } from '@/typings/interfaces/data/section';

export class FlowpageModel extends SectionBaseModel {
  constructor(data: SectionData, campaignModel: CampaignModel) {
    super(data, campaignModel);
  }

  public getSectionType() {
    return SectionType.FLOWPAGE;
  }

  public getSettingsModel(data: SettingsData): SettingsModel {
    return new FlowPageSettingsModel(data, this);
  }

  authorSignature(): string {
    return 'Sebastian Jakobsen';
  }

  get index(): number {
    return this.campaignModel.state.flowPages.indexOf(this);
  }
}
